export const webPortfolio = [
  {
    id: 1,
    title: "Turistando",
    img: "assets/turistando-front.gif",
    url: "https://github.com/FilipNeri/Turistando-Frontend",
  },
  {
    id: 2,
    title: "Dashboard Turistando",
    img: "assets/turistando-dashboard.gif",
    url: "https://github.com/FilipNeri/Turistando-Dashboard",
  },
  {
    id: 3,
    title: "Dashboard ERP",
    img: "assets/erp.gif",
    url: "https://github.com/FilipNeri/Dashboard-ERP",
  },
  {
    id: 4,
    title: "Back-end Turistando",
    img: "assets/nodejs_logo.jpg",
    url: "https://github.com/FilipNeri/Turistando-Backend",
  },
  {
    id: 5,
    title: "Back-end ERP",
    img: "assets/nodejs_logo.jpg",
    url: "https://github.com/FilipNeri/Dashboard-ERP-Back-end",
  },
  {
    id: 6,
    title: "Portfolio",
    img: "assets/portfolio.gif",
    url: "https://github.com/FilipNeri/Portfolio",
  },
];

export const mobilePortfolio = [
  {
    id: 1,
    title: "Cálculo da densidade de banho",
    img: "assets/calculoDensidade.gif",
    url: "https://github.com/FilipNeri/Calculo-de-Densidade-de-Banho",
  },
  {
    id: 2,
    title: "ATM Consultoria",
    img: "assets/atm.png",
    url: "https://github.com/FilipNeri/APP-Consultoria",
  },
];
